import * as types from './boards.types';
import * as constants from './boards.constants';
import { IMeeting } from '../../resource/meeting/meeting.types';

export const initialBoardsPage = (meetingId: IMeeting['id']): types.IInitialBoardsPage => ({
  type: constants.INITIAL_BOARDS_PAGE,
  payload: meetingId,
});

export const filterTasks = (inputValue: types.FilterTasks['inputValue']) => ({
  type: constants.FILTER_TASKS_FREETEXT,
  payload: inputValue,
});

export const filterTasksByDueDate = (date: Date | null) => ({
  type: constants.FILTER_TASKS_BY_DUE_DATE,
  payload: date,
});

export const filterByMemberIds = (memberIds: string[]) => ({
  type: constants.FILTER_TASKS_BY_MEMBER_IDS,
  payload: memberIds,
});
